module.exports = __webpack_public_path__ + "img/4D.0e6d8bb8.jpg";